// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7dbfcf4a","241":"0a6494d9","400":"c583f9d6"}[chunkId] + ".chunk.js";
};